module.exports = __webpack_public_path__ + "img/success.7347cd0e.png";